export default "__VITE_ASSET__c3772cce__"